import { PATH_FRAGMENTS } from './path-fragments.constants';

export const ROUTE_PATHS = {
  // AUTH
  AUTH: `${PATH_FRAGMENTS.AUTH.BASE}`,
  AUTH_LOGIN: `${PATH_FRAGMENTS.AUTH.BASE}/${PATH_FRAGMENTS.AUTH.LOGIN}`,

  // CUSTOMER
  CUSTOMER: `${PATH_FRAGMENTS.CUSTOMER.BASE}`,
  CUSTOMER_LIST: `${PATH_FRAGMENTS.CUSTOMER.BASE}/${PATH_FRAGMENTS.CUSTOMER.LIST}`,

  // POST
  POST: `${PATH_FRAGMENTS.POST.BASE}`,
  POST_FEED: `${PATH_FRAGMENTS.POST.BASE}/${PATH_FRAGMENTS.POST.POST_FEED}`,

  // CONFIG
  CONFIG: `${PATH_FRAGMENTS.CONFIG.BASE}`,
  CONFIG_GP: `${PATH_FRAGMENTS.CONFIG.BASE}/${PATH_FRAGMENTS.CONFIG.GP}`,
  CONFIG_SEASON: `${PATH_FRAGMENTS.CONFIG.BASE}/${PATH_FRAGMENTS.CONFIG.SEASON}`,
  CONFIG_NOTIFICATION: `${PATH_FRAGMENTS.CONFIG.BASE}/${PATH_FRAGMENTS.CONFIG.NOTIFICATION}`,

  // Ejemplo: '/dashboard'
  DASHBOARD: `${PATH_FRAGMENTS.DASHBOARD}`,
};




/*
1.- 
export const ROUTE_PATHS = {
  LOGIN: '/auth/login',
  DASHBOARD: '/dashboard',
  CONFIG_GP: (championshipId: string, gpId: string) => `/config/gp/${championshipId}/${gpId}`,
};

2.-
{
  path: 'config/gp/:championshipId/:gpId',
  component: GpComponent,
}

3.-
const championshipId = 'abc123';
const gpId = 'gp456';
this.router.navigateByUrl(ROUTE_PATHS.CONFIG_GP(championshipId, gpId));

4.-
const championshipId = this.route.snapshot.paramMap.get('championshipId');
  const gpId = this.route.snapshot.paramMap.get('gpId');

*/